<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <p class="mt-0 mb-3 text-sm text-600">
    Recurring sentences shown on the location and suburb pages — one edit here changes every page
    that uses the sentence. Words in curly braces like <span class="font-mono">{{ '{' }}region{{ '}' }}</span>
    are filled in per page; keep them as they are.
  </p>

  <table class="w-full" style="border-collapse: collapse">
    <tr *ngFor="let f of fragmentsAsList(account.data?.content)" class="border-bottom-1 border-100">
      <td class="py-2" style="width: 18rem"><strong>{{ f.name || f.key }}</strong></td>
      <td class="py-2 text-600 text-sm">{{ (f.copy || '').slice(0, 90) }}{{ (f.copy || '').length > 90 ? '…' : '' }}</td>
      <td class="py-2 text-right" style="width: 5rem">
        <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text"
          (click)="onEdit(f)" title="Edit"></button>
      </td>
    </tr>
  </table>

  <p *ngIf="!fragmentsAsList(account.data?.content).length" class="text-500 text-sm mt-3">
    <span *ngIf="!loadFailed">
      None yet — the site is using its built-in sentences. Run the seed script
      (seed-menus-and-copy.mjs) to make them editable here.
    </span>
    <span *ngIf="loadFailed" class="app-text-overdue">
      The content couldn't be loaded — this list is empty because of an error.
    </span>
  </p>

</ng-container>

<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
